import { render, staticRenderFns } from "./TrademarkOppositionStatusForm.vue?vue&type=template&id=02696ff8&"
import script from "./TrademarkOppositionStatusForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionStatusForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionStatusForm.vue?vue&type=style&index=0&id=02696ff8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports